import { useDownloadMutation } from '~/hooks/common';
import { axiosInstance, downloadBlobDataFile } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeGetInboundRequestProgressParams } from '~/types/receive.types';

type TypeGetInboundRequestProgressDownloadMutationParams = TypeGetInboundRequestProgressParams & {
  ownerCode: string;
};

const fetchInboundRequestProgressDownload = async ({
  ownerCode,
  ...params
}: TypeGetInboundRequestProgressDownloadMutationParams): Promise<void> => {
  const response = await axiosInstance.get(
    `${API_ENDPOINT.RECEIVE.GET_INBOUND_REQUEST_PROGRESS_DOWNLOAD}/${ownerCode}/inbound-request/progress/download`,
    {
      params,
      responseType: 'blob',
    }
  );

  downloadBlobDataFile(response);
};

/**
 * [입고관리 > 입고현황] 3PL 입고현황 엑셀 다운로드 Mutation Hook
 */
export const useGetInboundRequestProgressDownloadMutation = () => {
  return useDownloadMutation(fetchInboundRequestProgressDownload);
};
